<div class="autoComplete">
  <mat-form-field [floatLabel]="floatLabel ? '' : 'never'" [ngClass]="{'input-invalid' : !hiddenInvalid}">
    <mat-icon class="searchIcon" svgIcon="search" matPrefix *ngIf="isWorksheet"></mat-icon>
    <input spellcheck="false" (blur)="callBackWorksheet($event)" minlength="3" maxlength="50" matInput #autoInput
      type="text" class="active auto-complete-input" [matAutocomplete]="issuingAsset" (keypress)="keyPressed($event)"
      [formControl]="symbolCtrl" (paste)="onPaste($event)" [(ngModel)]="symbolAutoComplete" [ngClass]="{ 'empty': !symbolAutoComplete }"
      [placeholder]="placeHolderSetter" (keydown.enter)="onInputConfirm($event)" (keydown.tab)="onInputConfirm($event)" ondragstart="return false;"
      ondrop="return false;" appAutosizeInput [minWidth]="80" [maxWidth]="200" [autoSizeActive]="autoSizeActive">
  </mat-form-field>
  <mat-autocomplete autoActiveFirstOption #issuingAsset id="issuingAsset" (optionSelected)='optionSelected($event)'
    [autoActiveFirstOption]="false" class="custom-offset {{isWorksheet ?'worksheetClass' : ''}}">
    <mat-option *ngFor="let item of filteredAssets" [value]="item.symbol" (onSelectionChange)="onInputConfirm($event)">
      {{ item.symbol | uppercase }}</mat-option>
  </mat-autocomplete>
</div>
